/* Diwali 2026 free gifts, SITE-WIDE (V9.28.263, H648). Loaded (defer) by snippets/mes-diwali-gifts.liquid only while
   the campaign is on and at least one gift is configured. The same logic the homepage gift ladder used (assets/
   mes-diwali.js), lifted out so it runs on every page: a shopper who adds on a product page and checks out from the
   cart drawer still gets the gifts.
   Total = cart.items_subtotal_price minus every line carrying the _mes_gift property. A gift goes in once when the total
   reaches its amount and comes out when the total drops below. Loop guards: one reconcile at a time, always against a
   FRESH /cart.js read, a gift the shopper removed is never re-added this session, a hard cap on writes per window.
   India only. Small on purpose: no work until the page has loaded, then one /cart.js read per cart change. */
(function () {
  'use strict';
  if (window.__mesDiwaliGifts) return;
  window.__mesDiwaliGifts = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KEY_ADDED = 'mdwGiftAdded', KEY_DECLINED = 'mdwGiftDeclined';
  var cfgEl = document.querySelector('[data-mdw-gifts]');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent) || {}; } catch (e) { return; }
  var tiers = (cfg.tiers || []).map(function (t) {
    return { key: String(t.key), amt: Number(t.amt) || 0, vid: Number(t.vid) || 0, avail: !!t.avail };
  }).filter(function (t) { return t.amt > 0; });
  if (!tiers.length) return;
  var country = (window.Shopify && window.Shopify.country) || cfg.country || '';
  if (country !== 'IN') return;

  var store = {
    get: function (k) { try { return JSON.parse(sessionStorage.getItem(k) || '[]'); } catch (e) { return []; } },
    set: function (k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode */ } }
  };
  function fire(name) { document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: {} })); }
  function total(cart) {
    var t = Number(cart.items_subtotal_price);
    if (isNaN(t)) t = Number(cart.total_price) || 0;
    (cart.items || []).forEach(function (it) {
      if (it.properties && it.properties._mes_gift) t -= Number(it.final_line_price) || 0;
    });
    return Math.max(0, t) / 100;
  }

  var busy = false, again = false, timer = 0, writes = [], halted = false;
  function fetchCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function post(path, body) {
    writes.push(Date.now());
    return fetch(ROOT + path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || r.status); return j; }); });
  }
  function capped() {
    var now = Date.now();
    writes = writes.filter(function (w) { return now - w < 30000; });
    if (writes.length >= 8) { halted = true; console.warn('[mes-diwali-gifts] stopped for this page: too many cart writes in 30s'); }
    return halted;
  }

  function reconcile(cart) {
    if (halted || (cart.currency && cart.currency !== 'INR')) return Promise.resolve(false);
    var tot = total(cart), items = cart.items || [];
    var added = store.get(KEY_ADDED), declined = store.get(KEY_DECLINED);
    var adds = [], changes = [];
    tiers.forEach(function (t) {
      var lines = items.filter(function (it) { return it.properties && String(it.properties._mes_gift) === t.key; });
      var has = lines.length > 0;
      var want = tot >= t.amt && t.vid > 0 && t.avail;
      if (want && !has) {
        if (declined.indexOf(t.key) !== -1) return;
        if (added.indexOf(t.key) !== -1) {
          // We put it in, the cart still qualifies, and it is gone: the shopper took it out. Respect that.
          declined.push(t.key);
          added.splice(added.indexOf(t.key), 1);
          return;
        }
        adds.push({ id: t.vid, quantity: 1, properties: { _mes_gift: t.key } });
      } else if (!want && has) {
        lines.forEach(function (ln) { changes.push({ id: ln.key, quantity: 0 }); });
        if (added.indexOf(t.key) !== -1) added.splice(added.indexOf(t.key), 1);
      } else if (has) {
        // One gift per tier: fold extra quantity or duplicate lines back to a single unit.
        lines.forEach(function (ln, i) { var q = i === 0 ? 1 : 0; if (ln.quantity !== q) changes.push({ id: ln.key, quantity: q }); });
        if (added.indexOf(t.key) === -1) added.push(t.key);
      }
    });
    store.set(KEY_DECLINED, declined);
    store.set(KEY_ADDED, added);
    if (!adds.length && !changes.length) return Promise.resolve(false);
    if (capped()) return Promise.resolve(false);
    var chain = Promise.resolve();
    changes.forEach(function (c) { chain = chain.then(function () { return post('cart/change.js', c); }); });
    if (adds.length) {
      chain = chain.then(function () { return post('cart/add.js', { items: adds }); }).then(function () {
        var a = store.get(KEY_ADDED);
        adds.forEach(function (x) { var k = x.properties._mes_gift; if (a.indexOf(k) === -1) a.push(k); });
        store.set(KEY_ADDED, a);
      });
    }
    return chain.then(function () { return true; }, function (err) {
      console.warn('[mes-diwali-gifts] update failed:', err && err.message);
      return true;
    });
  }

  function run() {
    if (busy) { again = true; return; }
    busy = true;
    fetchCart().then(reconcile).then(function (wrote) {
      if (wrote) fire('cart:refresh'); // drawer, badge and the homepage ladder repaint; their cart:change lands back here as a no-op
    }).catch(function (e) {
      console.warn('[mes-diwali-gifts]', e && e.message);
    }).then(function () {
      busy = false;
      if (again) { again = false; schedule(); }
    });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 250); }
  ['cart:change', 'cart:refresh', 'variant:add'].forEach(function (n) { document.addEventListener(n, schedule); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
  if (document.readyState === 'complete') schedule(); else window.addEventListener('load', schedule, { once: true });
})();
